import { render, staticRenderFns } from "./DigitalPromoLayout.vue?vue&type=template&id=7214e888&"
import script from "./DigitalPromoLayout.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7214e888')) {
      api.createRecord('7214e888', component.options)
    } else {
      api.reload('7214e888', component.options)
    }
    module.hot.accept("./DigitalPromoLayout.vue?vue&type=template&id=7214e888&", function () {
      api.rerender('7214e888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/DigitalPromoLayout.vue"
export default component.exports